module.exports = __webpack_public_path__ + "img/MenuButton_WA.795f53f2.png";